import { render, staticRenderFns } from "./ProcedureWebmail.vue?vue&type=template&id=2bc09d83&scoped=true&"
import script from "./ProcedureWebmail.vue?vue&type=script&lang=js&"
export * from "./ProcedureWebmail.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureWebmail.vue?vue&type=style&index=0&id=2bc09d83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc09d83",
  null
  
)

export default component.exports